import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import {Route} from "react-router";
import {BrowserRouter as Router} from "react-router-dom";
import {createBrowserHistory} from "history";
import store from './store'

if (process.env.NODE_ENV !== 'development') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
    console.warn = () => {}
}



export const history = createBrowserHistory();

ReactDOM.render((
    <Provider store = {store}>
        <Router history={history}>
            <Route path="/" component={App}/>
        </Router>
    </Provider>
    ), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
